import React from 'react';

import {
  OrderDetailLayout,
  OrderDetailViewTemplate,
} from '../Detail/OrderDetailView';

const VoucherOrderDetailView = ({ data }) => {
  const { items } = data;

  const {
    additionalInfo: {
      senderName,
      senderMobile,
      recipientName,
      recipientMobile,
    },
  } = items[0];

  const GiftSenderInfoList = [
    ['주문자 이름', senderName],
    ['전화번호', senderMobile],
    ['수령인 이름', recipientName],
    ['수령인 연락처', recipientMobile],
  ];

  return (
    <OrderDetailViewTemplate data={data}>
      {senderMobile !== null && (
        <OrderDetailLayout title="주문자정보" infoList={GiftSenderInfoList} />
      )}
    </OrderDetailViewTemplate>
  );
};

export default React.memo(VoucherOrderDetailView);
